// extracted by mini-css-extract-plugin
export default {"uberHealthTag":"UberHealthTag_uberHealthTag__HoDUi","uberHealthIcon":"UberHealthTag_uberHealthIcon__TyVPx"};